export const jumpToAnchor = () => {
    setTimeout(function () {
        const anchorEl = window.location.hash && document.querySelector(window.location.hash);
        if (!anchorEl) {
            return;
        }
        // check if the anchor is visible, otherwise scroll into view
        if (!(anchorEl.getBoundingClientRect().top <= window.innerHeight)) {
            anchorEl.scrollIntoView({behavior: 'smooth', block: 'start' });
        }
    }, 500);
};
